import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../../assets/svg/inactive.svg',
})
export class InactiveComponent {}
